import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'jalali-moment';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const ProductOrdersList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('product_orders'), link: '/product-orders-list' },
		{ title: t('list') }
	];

	const [productOrders, setProductOrders] = useState([]);
	let productOrdersListData = {
		head: [t('creation_date'), t('user'), t('product'), t('status'), t('operation')],
		body: productOrders.map(productOrder => [
			moment(productOrder.create_date?.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			<Link className='' to={`/users-edit/${productOrder.user_id_information.user_id}`} target="_blank">
				{productOrder.user_id_information.user_fullname}
			</Link>,
			<Link className='' to={`/products-edit/${productOrder.product_id_information.product_id}`} target="_blank">
				{productOrder.product_id_information.product_name}
			</Link>,
			<span className={"badge rounded-pill p-2 badge-subtle-" + ((productOrder.order_state === 0) ? 'primary' : (productOrder.order_state === 1) ? 'secondary' : (productOrder.order_state === 2) ? 'info' : 'danger')}>
				{(productOrder.order_state === 0) ? t('pending') : (productOrder.order_state === 1) ? t('closed') : (productOrder.order_state === 2) ? t('sent') : t('failed')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/product-orders-edit/${productOrder.order_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['ltr', 'rtl', 'rtl', '', 'ltr']
	};
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchOrderProductID, setSearchOrderProductID] = useState(null);
	const [searchOrderUserID, setSearchOrderUserID] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getProductOrders = async () => {
		let body = {
			product_id: searchOrderProductID,
			user_id: searchOrderUserID,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/orders/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_orders);
				setProductOrders(response.data.orders);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getProductOrders();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<ListTable title={t('product_orders')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={productOrdersListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default ProductOrdersList;
